<template>
  <section class="wrapper">
    <van-row class="mt10" :gutter="5">
      <van-col :span="8">
        <van-button block size="small" :type="currentUrl==='main-business'?'primary':'default'"
                    @click="goto('main-business')">
          主营业务收入
        </van-button>
      </van-col>
      <van-col :span="8">
        <van-button block
                    size="small"
                    :type="currentUrl==='other-business'?'primary':'default'"
                    @click="goto('other-business')">
          其他业务收入
        </van-button>
      </van-col>
      <van-col :span="8">
        <van-button block size="small" :type="currentUrl==='operation'?'primary':'default'" @click="goto('operation')">
          营业外收入
        </van-button>
      </van-col>
    </van-row>
    <van-row class="mt10" :gutter="5">
      <van-col :span="8">
        <van-button block
                    size="small"
                    :type="currentUrl==='investment'?'primary':'default'"
                    @click="goto('investment')">
          投资收益
        </van-button>
      </van-col>
      <van-col :span="8">
        <van-button block
                    size="small"
                    :type="currentUrl==='search'?'primary':'default'"
                    @click="goto('search')">
          查询与编辑收入记录
        </van-button>
      </van-col>
    </van-row>
    <router-view class="content"></router-view>
  </section>
</template>

<script>
  export default {
    data() {
      return {
        currentUrl: ''
      }
    },
    methods: {
      goto(url) {
        this.$router.push(`/income/${url}`)
      }
    },
    watch: {
      $route: {
        handler(to, from) {
          const urlArray = to.path.split('/');
          this.currentUrl = urlArray[urlArray.length - 1];
        },
        immediate: true
      }
    }
  }
</script>

<style lang="less" scoped>
  .wrapper {
    padding: 0 1rem;
    overflow: hidden;

    .content {
      margin-top: 1rem;
      display: flex;
      flex-direction: column;
      height: calc(100% - 14rem);
      overflow: auto;
    }

  }

</style>
